import React, { FormEvent, useState } from "react";
import { CheckCircle2Icon, ShieldCheckIcon } from "lucide-react";
type QuoteFormProps = {
  defaultNeed?: string;
};
const needs = ["Ducted", "Split system", "Multi-split", "iZone control", "Replace existing", "Not sure"];
export function QuoteForm({
  defaultNeed = ""
}: QuoteFormProps) {
  const [selected, setSelected] = useState(defaultNeed);
  const [selectionError, setSelectionError] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    if (!selected) {
      setSelectionError(true);
      return;
    }
    setSubmitted(true);
  }
  if (submitted) {
    return <div className="flex min-h-[430px] flex-col justify-center rounded-lg bg-white p-7 text-center shadow-card" role="status" data-id="element-127" data-mp="2xvqra8fi2qsc">
        <CheckCircle2Icon className="mx-auto h-11 w-11 text-rinnai" data-id="element-128" data-mp="3buqercra0zmx" />
        <h2 className="mt-5 text-2xl font-bold tracking-tight text-ink" data-id="element-129" data-mp="36wf8fc06x79g">Thanks. Your quote request is ready.</h2>
        <p className="mt-3 text-sm leading-6 text-muted" data-id="element-130" data-mp="3gpb3try3l33k">A Perth Home Air Conditioning specialist will contact you to understand your home and recommend the right next step.</p>
        <button type="button" onClick={() => setSubmitted(false)} className="mt-6 text-sm font-bold text-rinnai underline underline-offset-4" data-id="element-131" data-mp="3qkuykb0xdvqq">
          Send another request
        </button>
      </div>;
  }
  return <form id="quote" onSubmit={handleSubmit} className="rounded-lg bg-white p-6 shadow-card lg:p-7" data-id="element-132" data-mp="3gotvldr05pq">
      <div className="flex items-start justify-between gap-4" data-id="element-133" data-mp="8eqe49mwub2s">
        <div data-id="element-134" data-mp="d6rkxg1b79lf">
          <p className="text-sm font-bold text-rinnai" data-id="element-135" data-mp="d82s7ptyqzha">FREE · NO OBLIGATION</p>
          <h2 className="mt-1 text-2xl font-bold tracking-tight text-ink" data-id="element-136" data-mp="i6mfpuo7gjbr">Get your free Rinnai quote</h2>
        </div>
        <ShieldCheckIcon className="mt-1 h-6 w-6 shrink-0 text-rinnai" aria-hidden="true" data-id="element-137" data-mp="m8r3icrz2lqh" />
      </div>

      <fieldset className="mt-5" aria-describedby={selectionError ? "system-error" : undefined} data-id="element-138" data-mp="r7ki68izwis8">
        <legend className="text-sm font-bold text-ink" data-id="element-139" data-mp="2naqnhm2uq4xt">What are you looking for?</legend>
        <input type="hidden" name="systemInterest" value={selected} data-id="element-140" data-mp="2j9dgh8o0vvpb" />
        <div className="mt-2 flex flex-wrap gap-2" data-id="element-141" data-mp="2wzgwvj080v6u">
          {needs.map(need => <button key={need} type="button" aria-pressed={selected === need} onClick={() => {
          setSelected(need);
          setSelectionError(false);
        }} className={`rounded-full border px-3 py-2 text-xs font-semibold transition-colors duration-150 ease-out focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-rinnai focus-visible:ring-offset-2 ${selected === need ? "border-rinnai bg-rinnai text-white" : "border-line bg-white text-ink hover:border-ink"}`} data-id="element-142" data-mp="2s90jfyweh9kh">
              {need}
            </button>)}
        </div>
        {selectionError && <p id="system-error" className="mt-2 text-xs font-semibold text-rinnai" role="alert" data-id="element-143" data-mp="1gnlcxocjtv08">Choose an option, or select “Not sure”.</p>}
      </fieldset>

      <div className="mt-5 grid gap-3 sm:grid-cols-2 lg:grid-cols-1 xl:grid-cols-2" data-id="element-144" data-mp="12svp26nljx1">
        <label className="block text-sm font-semibold text-ink" data-id="element-145" data-mp="3jh225go9zym0">
          Name
          <input required name="name" autoComplete="name" className="mt-1.5 h-11 w-full rounded-md border border-line px-3 text-base font-normal outline-none transition-colors duration-150 ease-out focus:border-rinnai focus:ring-2 focus:ring-rinnai/15" data-id="element-146" data-mp="3ni42y1xuciq3" />
        </label>
        <label className="block text-sm font-semibold text-ink" data-id="element-147" data-mp="3eiqv1dpd827h">
          Phone
          <input required name="phone" type="tel" autoComplete="tel" className="mt-1.5 h-11 w-full rounded-md border border-line px-3 text-base font-normal outline-none transition-colors duration-150 ease-out focus:border-rinnai focus:ring-2 focus:ring-rinnai/15" data-id="element-148" data-mp="30izh1cyumlth" />
        </label>
        <label className="block text-sm font-semibold text-ink sm:col-span-2 lg:col-span-1 xl:col-span-2" data-id="element-149" data-mp="12qv9s3v1kvy9">
          Perth suburb or postcode
          <input required name="location" autoComplete="postal-code" className="mt-1.5 h-11 w-full rounded-md border border-line px-3 text-base font-normal outline-none transition-colors duration-150 ease-out focus:border-rinnai focus:ring-2 focus:ring-rinnai/15" data-id="element-150" data-mp="dz62scl9pcox" />
        </label>
      </div>

      <button type="submit" className="mt-5 h-12 w-full rounded-md bg-rinnai px-5 text-sm font-bold text-white transition-colors duration-150 ease-out hover:bg-rinnaiDark focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-rinnai focus-visible:ring-offset-2" data-id="element-151" data-mp="3v943is0891cj">
        GET MY FREE RINNAI QUOTE
      </button>
      <p className="mt-3 text-center text-xs leading-5 text-muted" data-id="element-152" data-mp="3ciw8yyalfj7y">No model number needed. We’ll clarify your home and recommend the next step.</p>
    </form>;
}